<template>
  <div>
    <div class="title">유관기관 비상연락망</div>

    <table v-if="!!data">
      <colgroup>
        <col />
        <col />
        <col width="140" />
        <col />
        <col />
        <col width="140" />
        <col />
        <col />
      </colgroup>
      <tbody>
        <!-- ROW1 -->
        <tr>
          <th colspan="2">경상북도 안전총괄관</th>
          <td class="diagonal empty-block"></td>
          <th colspan="2">구미시청</th>
          <td class="diagonal empty-block"></td>
          <th colspan="2">구미시청 종합상황실</th>
        </tr>
        <tr>
          <td>{{ data.list_1[0].input1 }}</td>
          <td>{{ data.list_1[0].input2 }}</td>
          <td class="empty-block"></td>
          <td colspan="2">{{ data.list_2[0].input1 }}</td>
          <td class="empty-block"></td>
          <td colspan="2">{{ data.list_3[0].input1 }}</td>
        </tr>
        <tr>
          <td>{{ data.list_1[1].input1 }}</td>
          <td>{{ data.list_1[1].input2 }}</td>
          <td class="empty-block"></td>
          <td colspan="2">{{ data.list_2[0].input2 }}</td>
          <td class="empty-block"></td>
          <td colspan="2">{{ data.list_3[0].input2 }}</td>
        </tr>
        <!-- END:ROW1 -->
        <tr>
          <td colspan="2" class="empty-block"></td>
          <td class="tlbr diagonal empty-block"></td>
          <td colspan="2" class="empty-block"></td>
          <td class="bltr diagonal empty-block"></td>
          <td colspan="2" class="empty-block"></td>
        </tr>
        <!-- ROW2 -->
        <tr>
          <th colspan="2">대구지방고용노동청</th>
          <td class="empty-block"></td>
          <th colspan="2">사업장</th>
          <td class="empty-block"></td>
          <th colspan="2">구미소방서</th>
        </tr>
        <tr>
          <td colspan="2">{{ data.list_4[0].input1 }}</td>
          <td class="diagonal empty-block"></td>
          <td colspan="2">{{ data.fieldInfo.field_name }}</td>
          <td class="diagonal empty-block"></td>
          <td>{{ data.list_5[0].input1 }}</td>
          <td>{{ data.list_5[0].input2 }}</td>
        </tr>
        <tr>
          <td colspan="2">{{ data.list_4[0].input2 }}</td>
          <td class="empty-block"></td>
          <td colspan="2">{{ data.fieldInfo.address }}</td>
          <td class="empty-block"></td>
          <td>{{ data.list_5[1].input1 }}</td>
          <td>{{ data.list_5[1].input2 }}</td>
        </tr>
        <!-- END:ROW2 -->
        <tr>
          <td colspan="2" class="empty-block"></td>
          <td class="bltr diagonal empty-block"></td>
          <td colspan="2" class="empty-block"></td>
          <td class="tlbr diagonal empty-block"></td>
          <td colspan="2" class="empty-block"></td>
        </tr>
        <!-- ROW3 -->
        <tr>
          <th colspan="2">한국산업안전보건공단</th>
          <td class="empty-block"></td>
          <th colspan="2">전기안전공사(경북지역본부)</th>
          <td class="empty-block"></td>
          <th colspan="2">한국전력공사(경북본부직할)</th>
        </tr>
        <tr>
          <td colspan="2">{{ data.list_6[0].input1 }}</td>
          <td class="empty-block"></td>
          <td colspan="2">{{ data.list_7[0].input1 }}</td>
          <td class="empty-block"></td>
          <td colspan="2">{{ data.list_8[0].input1 }}</td>
        </tr>
        <tr>
          <td colspan="2">{{ data.list_6[0].input2 }}</td>
          <td class="empty-block"></td>
          <td colspan="2">{{ data.list_7[0].input2 }}</td>
          <td class="empty-block"></td>
          <td colspan="2">{{ data.list_8[0].input2 }}</td>
        </tr>
        <!-- END:ROW3 -->
        <tr>
          <td colspan="8" class="empty-block"></td>
        </tr>
        <!-- ROW4 -->
        <tr>
          <th colspan="2">한국가스공사(경북지역본부)</th>
          <td class="empty-block"></td>
          <th colspan="2">한국승강기안전공단(경북지역본부)</th>
          <td class="empty-block"></td>
          <th colspan="2">국토교통부 건설정책국</th>
        </tr>
        <tr>
          <td colspan="2">{{ data.list_9[0].input1 }}</td>
          <td class="empty-block"></td>
          <td colspan="2">{{ data.list_10[0].input1 }}</td>
          <td class="empty-block"></td>
          <td colspan="2">{{ data.list_11[0].input1 }}</td>
        </tr>
        <tr>
          <td colspan="2">{{ data.list_9[0].input2 }}</td>
          <td class="empty-block"></td>
          <td colspan="2">{{ data.list_10[0].input2 }}</td>
          <td class="empty-block"></td>
          <td colspan="2">{{ data.list_11[0].input2 }}</td>
        </tr>
        <!-- END:ROW4 -->
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: { listLabels: Array, form: Object },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.data = this.setData(value);
      },
    },
  },
  data() {
    return { data: this.setData(this.form) };
  },
  methods: {
    setData() {
      let _data = JSON.parse(JSON.stringify(this.form));
      this.listLabels.map((_, _i) => {
        _data[`list_${_i + 1}`] = _data[`list_${_i + 1}`].map((_, _j) => {
          return {
            input1: _data[`list_${_i + 1}`][_j].input1 ? _data[`list_${_i + 1}`][_j].input1 : "-",
            input2: _data[`list_${_i + 1}`][_j].input2 ? _data[`list_${_i + 1}`][_j].input2 : "-",
          };
        });
      });
      return _data;
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-family: Noto Sans KR;
  font-size: 24px;
  font-weight: 700;
  line-height: 35px;
  letter-spacing: 0em;
  text-align: center;
  padding: 20px 0;
  margin-bottom: 48px;
}

table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  th {
    font-weight: bold;
    font-size: 14px;
    font-weight: 400;
    text-align: center;

    background: #f9f9f9;
    border: 1px solid #cdcdcd;
    padding: 10px 0;
  }
  td {
    font-size: 14px;
    font-weight: 400;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 20px 4px;

    &.empty-block {
      border: 0px;
      padding: 28px 0;
    }
  }
}

.diagonal {
  background-size: 120% 120%;
  background-position: center;
  background-image: linear-gradient(to top, transparent calc(50% - 1px), #cdcdcd, transparent calc(50% + 1px));

  &.tlbr {
    background-image: linear-gradient(to left bottom, transparent calc(50% - 1px), #cdcdcd, transparent calc(50% + 1px));
  }
  &.trbl {
    background-image: linear-gradient(to right bottom, transparent calc(50% - 1px), #cdcdcd, transparent calc(50% + 1px));
  }
  &.bltr {
    background-image: linear-gradient(to bottom right, transparent calc(50% - 1px), #cdcdcd, transparent calc(50% + 1px));
  }
  &.brtl {
    background-image: linear-gradient(to bottom left, transparent calc(50% - 1px), #cdcdcd, transparent calc(50% + 1px));
  }
}
</style>
